import React, { useEffect, useState } from "react";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

export default function OpeningStock() {
  const [products, setProducts] = useState([]);
  const [entries, setEntries] = useState([]);
  const [unitCost, setUnitCost] = useState("");
   const [expiryDate, setExpiryDate] = useState("");


  const [form, setForm] = useState({
    product_id: "",
    opening_qty: ""
  });

  // -------------------------------
  // Load products from backend
  // -------------------------------
  const loadProducts = async () => {
    const res = await fetch(`${API_BASE}/products/list`, {
      headers: authHeaders(),
    });
    const data = await res.json();
    setProducts(Array.isArray(data) ? data : []);
  };

  // -------------------------------
  // Load existing opening stock entries
  // -------------------------------
  const loadEntries = async () => {
    const res = await fetch(`${API_BASE}/inventory/opening/list`, {
      headers: authHeaders(),
    });
    const data = await res.json();
    if (data.success) setEntries(data.data);
  };

  useEffect(() => {
    loadProducts();
    loadEntries();
  }, []);

  // -------------------------------
  // Save Opening Stock
  // -------------------------------
  const saveOpeningStock = async () => {
    if (!form.product_id || !form.opening_qty) {
      alert("Please select product and enter opening quantity");
      return;
    }

    const res = await fetch(`${API_BASE}/inventory/opening`, {
      method: "POST",
      headers: authHeaders({
          "Content-Type": "application/json",
        }),
      body: JSON.stringify({
  product_id: form.product_id,
  opening_qty: form.opening_qty,
  unit_cost: Number(unitCost),
  expiry_date: expiryDate || null,
}),
 });

    const data = await res.json();

    if (data.success) {
      alert("Opening stock saved!");
      setForm({ product_id: "", opening_qty: "" });
      setUnitCost("");
      setExpiryDate("");
      loadEntries();
    } else {
      alert(data.message || "Error saving opening stock");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Opening Stock</h2>

      {/* ---------------------- FORM CARD ---------------------- */}
      <div
        style={{
          width: "400px",
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "30px",
          boxShadow: "0 0 10px rgba(0,0,0,0.15)",
        }}
      >
        <h3>Set Opening Stock</h3>

        {/* PRODUCT */}
        <select
          value={form.product_id}
          onChange={(e) =>
            setForm({ ...form, product_id: e.target.value })
          }
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "12px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        >
          <option value="">Select Product</option>
          {products.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>

        {/* OPENING QTY */}
        <input
          type="number"
          placeholder="Opening Quantity"
          value={form.opening_qty}
          onChange={(e) =>
            setForm({ ...form, opening_qty: e.target.value })
          }
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "12px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        />

        <input
          type="number"
          step="0.01"
          placeholder="Avg Cost (₹)"
          value={unitCost}
          onChange={(e) => setUnitCost(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "12px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        />
<input
  type="date"
  value={expiryDate}
  onChange={(e) => setExpiryDate(e.target.value)}
  style={{
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  }}
/>


        <button
          onClick={saveOpeningStock}
          style={{
            width: "100%",
            padding: "10px",
            background: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Save Opening Stock
        </button>
      </div>

      {/* ---------------------- LIST TABLE ---------------------- */}
      <h3>Opening Stock Entries</h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#eee" }}>
            <th style={{ padding: "10px" }}>Product</th>
            <th style={{ padding: "10px" }}>Opening Qty</th>
            <th style={{ padding: "10px" }}>Expiry Date</th>
            <th style={{ padding: "10px" }}>Created At</th>
          </tr>
        </thead>
        <tbody>
          {entries.length === 0 ? (
            <tr><td colSpan="4" style={{ padding: "10px" }}>No entries found</td></tr>
          ) : (
            entries.map((e, index) => (
              <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
  <td style={{ padding: "10px" }}>{e.product_name}</td>
  <td style={{ padding: "10px" }}>{e.opening_qty}</td>

  {/* NEW: Expiry Date column */}
  <td style={{ padding: "10px" }}>
    {e.expiry_date ? new Date(e.expiry_date).toLocaleDateString() : "-"}
  </td>

  {/* Existing: Opening Date */}
  <td style={{ padding: "10px" }}>
    {new Date(e.opening_date).toLocaleString()}
  </td>
</tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
